export const iconFontAwesomeUsersPeoplePersonWalkingWithCane = (
	<i className="fa-solid fa-person-walking-with-cane"></i>
);
